import type { DinersStatus } from "@/api/admin/diners";
import type { PaginatedResponse } from "@/types/api";

export interface RestaurantDinerType {
  id: string;
  name: string;
  lastVisit: string;
  totalOrders: number;
  totalSpent: number;
}

export type RestaurantDinerResponse = PaginatedResponse<RestaurantDinerType>;

export enum DinerPath {
  GROUP = "group",
  BRAND = "brand",
  BRANCH = "branch",
}

export interface IDinerRestaurantInfo {
  id: string;
  fullName: string;
  email: string;
  phoneNumber?: string | null;
  city: string;
  birthDate: string | null;
  languagePreference: string;
  createdAt: string;
  status: DinersStatus;
  tierName?: string | null;
  lastVisit: string;
  totalOrders: number;
  totalSpent: number;
  totalTips: number;
  mobileOs?: string | null;
  deviceType?: string | null;
}
